import { SVGProps } from 'react';

const Glasses = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 15a4 4 0 1 1-8 0 4 4 0 0 1 8 0m0 0a2 2 0 0 1 4 0m0 0a4 4 0 1 0 8 0 4 4 0 0 0-8 0M2.5 13 5 7c.7-1.3 1.4-2 3-2m13.5 8L19 7c-.7-1.3-1.5-2-3-2"
    />
  </svg>
);
export default Glasses;
